<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.orderNum" style="width: 140px;" size="mini" placeholder="销售订单号"
                        clearable></el-input>
                        <el-input v-model="formDatas.userName" style="width: 140px;" size="mini" placeholder="用户名"
                        clearable></el-input>
                    <el-input v-model="formDatas.zaituCode" style="width: 140px;" size="mini" placeholder="在途订单类型"
                        clearable></el-input>
                    <el-select v-model="formDatas.fzsiStatus" size="mini" clearable placeholder="同步纷享状态"
                        style="width: 130px" @change="partserch">
                        <el-option label="未处理" :value="1" key="1"></el-option>
                        <el-option label="已处理" :value="2" key="2"></el-option>
                        <el-option label="已同步" :value="3" key="3"></el-option>
                        <el-option label="同步失败" :value="4" key="4"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.fzsiStatusInit" clearable @change="partserch" placeholder="需要同步"
                       style="width: 170px">
                        <el-option label="不需要" :value="2" key="2"></el-option>
                        <el-option label="需要" :value="1" key="1"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="fzsiId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>

            <!-- 详情 -->
            <el-dialog title="详情" :visible.sync="IsDetail" width="80%" top="8vh">
                <json-viewer :value="treedata" :expand-depth=5 copyable boxed sort></json-viewer>
            </el-dialog>
        </div>
    </div>
</template>

<script>

import { getFxxkZaituSyncItineraryList, addAjPurchasePublicItem, updateAjPurchasePublicItem, deleteAjPurchasePublicItem, getFxxkZaituSyncItineraryDetails, updateFxxkOpportunityFilesDesStatus } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            treedata:'',
            IsDetail: false,
            DetailArr: '',
            key: 'fzsiId',
            dialog: false,
            edit: false,
            form: {
                appiName: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: false,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                // {
                //     field: "",
                //     key: "checkbox",
                //     type: "checkbox",
                //     fixed: 'left',
                //     title: "",
                //     width: 50,
                //     align: "center",
                // },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },

                {
                    field: "orderNum",
                    key: "orderNum",
                    title: "销售订单号",
                    align: "center",
                    edit: false,
                    fixed: 'left',
                    width: 160,
                },
                {
                    field: "userName",
                    key: "userName",
                    title: "用户名",
                    align: "center",
                    fixed: 'left',
                    edit: false,
                    width: 100,
                },
                {
                    field: "userCode",
                    key: "userCode",
                    title: "用户账号",
                    align: "center",
                    fixed: 'left',
                    edit: false,
                    width: 100,
                },
                {
                    field: "zaituCode",
                    key: "zaituCode",
                    title: "订单类型",
                    align: "center",
                    edit: false,
                    width: 160,
                },
                {
                    field: "bizType",
                    key: "bizType",
                    title: "10-机票;11-酒店;12-火车;13-国际酒店;14-需求单;15-保险;16-用车;17-国际机票;20-服务费订单",
                    align: "center",
                    edit: false,
                    width: 180,
                },
                {
                    field: "orderType",
                    key: "orderType",
                    title: "1-正向订单;2-改签订单;3-抢票订单;9-退单",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "bizOrderTypeEnum",
                    key: "bizOrderTypeEnum",
                    title: "bizOrderTypeEnum",
                    align: "center",
                    edit: false,
                    width: 90,
                },

                {
                    field: "status",
                    key: "status",
                    title: "订单状态",
                    align: "center",
                    edit: false,
                    width: 100,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 3,
                    },
                },
                { field: "orderOriginType", key: "orderOriginType", title: "订单来源类型", width: 120, align: "center" },
                { field: "empName", key: "empName", title: "预订人姓名", width: 120, align: "center" },
                { field: "empMobile", key: "empMobile", title: "预订人手机", width: 120, align: "center" },
                { field: "empOrgName", key: "empOrgName", title: "预订人部门", width: 120, align: "center" },
                { field: "fzsiSummary", key: "fzsiSummary", title: "行程摘要", width: 250, align: "center" },
                { field: "fzsiSummaryTofxxk", key: "fzsiSummaryTofxxk", title: "同步纷享的信息", width:400, align: "center" },
                { field: "travelStartTime", key: "travelStartTime", title: "旅行开始时间", width: 120, align: "center" },
                { field: "travelEndTime", key: "travelEndTime", title: "旅行结束时间", width: 120, align: "center" },
                { field: "createtime", key: "createtime", title: "创建时间", width: 120, align: "center" },

                {
                    field: "originalOrderId",
                    key: "originalOrderId",
                    title: "原始订单号",
                    align: "center",
                    edit: false,
                    width: 180,
                },
                {
                    field: "parentOrderId",
                    key: "parentOrderId",
                    title: "关联订单号",
                    align: "center",
                    edit: false,
                    width: 110,
                },
                { field: "bizOrderId", key: "bizOrderId", title: "关联业务订单号", width: 140, align: "center" },
                { field: "fzsiStatusMsg", key: "fzsiStatusMsg", title: "状态说明", width: 200, align: "center",},
                { field: "fzsiStatus", key: "fzsiStatus", title: "同步纷享", width: 80, align: "center", fixed: 'right',},
                { field: "fzsiStatusInit", key: "fzsiStatusInit", title: "需要同步", width: 80, align: "center", fixed: 'right',},
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 100,
                    align: "center",
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleDetail(row)}
                                >
                                    详情
                                </el-button>

                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                orderNum: '',
                userName:"",
                zaituCode: '',
                fzsiStatus: '',
                fzsiStatusInit:1,
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        DownDd(val) {
            this.openLoading()
            updateFxxkOpportunityFilesDesStatus({ fzsiId: val.fzsiId }).then(res => {
                if (res.data) {
                    this.loadings.close()
                    getFxxkZaituSyncItineraryDetails({ fzsiId: val.fzsiId }).then(ress => {
                        this.DetailArr = ress.data;
                        this.$message({
                            type: "success",
                            message: "下载成功!",
                        });
                    })
                } else {
                    this.loadings.close()
                }
            }).catch(err => {
                if (err) {
                    this.loadings.close()
                }
            })
        },
        handleDetail(row) {
            getFxxkZaituSyncItineraryDetails({ fzsiId: row.fzsiId }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
                this.treedata = res.data
                console.log(this.DetailArr);
            })
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAjPurchasePublicItem({ fzsiIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjPurchasePublicItem({ fzsiIds: row.fzsiId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjPurchasePublicItem(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjPurchasePublicItem(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.fzsiId = row.fzsiId
                    console.log(jsonObj);
                    updateAjPurchasePublicItem(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getFxxkZaituSyncItineraryList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getFxxkZaituSyncItineraryList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getFxxkZaituSyncItineraryList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>